<template>
  <div :class="tooltipClass">
    <slot></slot>
    <span ds-component="DsTooltip" class="ds-tooltip__content">
      {{ content }}
    </span>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'Tooltip',
  props: {
    position: {
      type: String,
      default: 'right'
    },
    content: {
      type: String,
      default: ''
    },
    open: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    tooltipClass() {
      return ['ds-tooltip', this.position, { open: this.open }];
    }
  }
});
</script>

<style lang="scss" scoped>
@import '~@ds/styles/Tooltip.scss';
</style>
